import { render, staticRenderFns } from "./ComDivAutocompleteMultiple.vue?vue&type=template&id=130ef8a9"
import script from "./ComDivAutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./ComDivAutocompleteMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports